<template>
    <div ref="detailsDialog" data-cy="product-details-dialog">
        <v-row>
            <v-col cols="4" style="position: relative">
                <product-image class="product-image" :btnFullScreen="true" contain :key="product.invoice_code" :productCode="product.invoice_code" :imageSrc="product.thumbnail" :imageSrcZoom="product.image" :isZoomable="true"></product-image>

                <div v-if="product.new == 1" class="new-product-label btn-bg-color-secondary-blue white-color font-size-sm d-flex">
                    <span style="margin-top: 1px; margin-bottom: -1px">&nbsp;{{ $t('orders.base.newProduct') }}&nbsp;</span>
                </div>
            </v-col>

            <v-col cols="8" class="pr-12">
                <v-card-title class="pa-0 d-flex product-details-bigger-text product-details-name dark-blue-color" data-cy="product-details-designation" style="height: 65px">
                    {{ product.designation }}
                   <!-- <v-btn > <v-icon  v-if="userStore.hasPermissionTo('Change bonus quantity (as propec)')" color="#154579"> mdi-share-variant </v-icon></v-btn>-->
                    <v-btn  v-if="userStore.hasPermissionTo('Change bonus quantity (as propec)')" class="elevation-2 ml-2 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" x-small fab @click="shareProduct(product)">
                                <v-icon>mdi-share-variant</v-icon>
                    </v-btn>
                </v-card-title>

                <div class="mb-2 d-flex justify-space-between align-center">
                    <div>
                        <div v-if="product.laboratory.name" class="pb-4">
                            <v-card-subtitle class="pa-0 d-flex product-details-big-text product-details-laboratory light-blue-color" data-cy="product-details-laboratory">
                                {{ this.product.laboratory.name }}
                            </v-card-subtitle>
                        </div>
                        <div style="height: 36px" v-else></div>

                        <p class="mb-0 description-text d">
                            {{ $t('products.reference') }}:&nbsp;<span class="font-size-xs" style="font-weight: bold">{{ product.code }}</span>
                        </p>
                        <p class="mb-0 description-text d" v-if="product.ean!=null">
                            EAN:&nbsp;<span class="font-size-xs" style="font-weight: bold">{{ product.ean }}</span>
                        </p>
                        <p class="mb-0 description-text d-flex align-center" v-if="userStore.hasPermissionTo('View product stocks (traffic lights)')" data-cy="product-stock">
                            {{ $t('products.availability') }}:
                            <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-if="!product.orderable" :color="isAvailable(product) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                    <v-icon v-else color="blue" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                </template>
                                <span v-if="!product.orderable">{{ isAvailable(product) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                <span v-else>{{ $t('orders.base.orderableConfirmStock') }}</span>
                            </v-tooltip>
                        </p>

                        <p class="mb-0 description-text d-flex align-center" :style="{ visibility: hasAdditionalInfo ? 'visible' : 'hidden' }">
                            {{ $t('products.additionalInfo') }}
                            <product-additional-info class="pr-8" :inDetails="true" :product="product"> </product-additional-info>
                        </p>
                    </div>
                    <div v-if="product.has_campaign && parentPage != 'affinity' && !product.hide_shopping_button && userStore.hasPermissionTo('View campaign icon') && !normalOrderStore.checkIfPubArticle(product)">
                        <v-card class="elevation-0 btn-bg-color-dark-yellow" style="border-radius: 16px 0px 0px 16px; display: inline-table; margin-right: -60px" @click="handleCampaignClick(product)">
                            <div class="d-flex justify-space-around align-center" style="min-height: 60px; height: 7vh; min-width: 180px">
                                <campaign-tooltip v-if="productHasActiveCampaign(product.id)" isOutlined inProductDetails></campaign-tooltip>
                                <campaign-tooltip v-else-if="!productHasActiveCampaign(product.id) && product.has_campaign" inProductDetails></campaign-tooltip>

                                <span class="mx-auto title-text light-yellow-color" style="cursor: pointer !important"> {{ $t('orders.pending.campaign') }} </span>
                            </div>
                        </v-card>
                    </div>
                </div>

                <div v-if="userStore.hasPermissionTo('View prices')" class="mt-4 mb-0 d-flex align-center" data-cy="product-details-price">
                    <div v-if="product.price === 0 && !normalOrderStore.checkIfPubArticle(product)">
                        <span class="product-details-bigger-text mb-0 dark-blue-color">{{ $t('products.priceOnRequest') }}</span>
                    </div>

                    <div v-else>
                        <span class="product-details-bigger-text mb-0 dark-blue-color">
                            {{ formatPrice(product.price) }}
                        </span>
                        <product-discounts-icon :inTable="true" v-if="userStore.hasPermissionTo('View discounts icon')" :product="product"></product-discounts-icon>
                        <span class="description-text font-size-md ml-2">({{ $t('products.exclVat') }})</span>
                    </div>
                </div>

                <div class="mb-2 d-flex align-center">
                    <p v-if="product.price !== 0" class="mb-0 description-text font-size-md" data-cy="product-details-tax">{{ $t('orders.base.vat') }}: {{ product.vat.tax }}%</p>
                    <p v-else class="mb-0 description-text font-size-md">&nbsp;</p>
                </div>

                <div class="d-flex align-center text-center" data-cy="product-details-quantity-counter">
                    <quantity-counter
                        v-if="(product.price !== 0 || normalOrderStore.checkIfPubArticle(product)) && !viewingSubstituteProduct && parentPage !== 'shoppingCart' && parentPage !== 'summary' && !product.hide_shopping_button"
                        :value="isInCart ? (storeQuantity > 0 ? storeQuantity : product.quantity) : quantity"
                        :min="1"
                        :max="maxQuantity"
                        dense
                        @input="onQuantityUpdated($event)"
                        @decrement="increment(-1)"
                        @increment="increment(1)"
                        input-class="set-field-size rounded-lg mx-3"
                        :hide-counter="branchStore.cannotPurchase"
                        :hide-input="branchStore.cannotPurchase"
                    ></quantity-counter>

                    <v-btn v-if="(product.price !== 0 || normalOrderStore.checkIfPubArticle(product))  && isInCart && !viewingSubstituteProduct && parentPage !== 'shoppingCart' && parentPage !== 'summary'&& !product.hide_shopping_button" text class="myprovet-btn-cancel details-btn-small mx-8 px-8" @click="remove" data-cy="product-details-remove-btn"> {{ $t('campaigns.remove') }} </v-btn>
                    <v-btn v-else-if="(product.price !== 0 || normalOrderStore.checkIfPubArticle(product)) && !viewingSubstituteProduct && parentPage !== 'shoppingCart' && parentPage !== 'summary'&& !product.hide_shopping_button && !branchStore.cannotPurchase" text class="myprovet-btn-ok details-btn-small mx-8 px-8" @click="tryPurchase" data-cy="product-details-buy-btn"> {{ $t('products.buy') }} </v-btn>

                    <div class="media-icons" style="min-height: 24px">
                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRcmFile">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="#154579" v-on="on" v-bind="attrs" @click="openRcm"> mdi-check-decagram </v-icon>
                            </template>
                            <span>RCM</span>
                        </v-tooltip>

                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasFsegFile">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="#154579" v-on="on" v-bind="attrs" @click="openFseg"> mdi-shield-check </v-icon>
                            </template>
                            <span>FSEG</span>
                        </v-tooltip>

                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="pdfSrc">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="#154579" v-on="on" v-bind="attrs" @click="openPdf"> mdi-note-text-outline </v-icon>
                            </template>
                            <span>PDF</span>
                        </v-tooltip>

                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="videoSrc">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="#154579" v-on="on" v-bind="attrs" @click="openVideoDialog"> mdi-youtube </v-icon>
                            </template>
                            <span>{{ $t('products.video') }}</span>
                        </v-tooltip>
                    </div>
                </div>

                <div class="d-flex align-center font-size-md mt-1" :style="{ visibility: hasAltProducts ? 'visible' : 'hidden' }">
                    <v-icon class="secondary-blue-color"> mdi-alert-circle-outline </v-icon>
                    <div style="margin-top: 4px">
                        <span class="description-text product-replaced-by-text">&nbsp;<b>{{ $t('products.replacedBy') }}</b></span>
                        &nbsp;
                        <span class="secondary-blue-color" style="cursor: pointer" v-for="(altProduct, altIndex) in product.substitute_products" :key="altProduct.id" @click="changeProduct(altProduct)">
                            {{ altProduct.designation }}
                            <span v-if="product.substitute_products[altIndex + 1] != null">,&nbsp;</span>
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-tabs v-model="tabIndex" class="details-tabs">
            <v-tab class="font-weight-bold" :class="tabIndex === 0 ? 'secondary-blue-color' : 'dark-blue-color'">{{ $t('products.generalInfo') }}</v-tab>
            <v-tab class="font-weight-bold" :class="tabIndex === 1 ? 'secondary-blue-color' : 'dark-blue-color'">{{ $t('products.indication') }}</v-tab>
            <v-tab v-if="userStore.hasPermissionTo('View product stocks')" class="font-weight-bold" :class="tabIndex === 2 ? 'secondary-blue-color' : 'dark-blue-color'">{{ $t('products.stocks') }}</v-tab>
        </v-tabs>

        <div class="product-tab" @scroll="onScroll" ref="productTab" v-if="tabIndex === 0">
            <div class="pr-12">
                <table>
                    <template v-if="product.dispense_regime">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.dispensingRegime') }}</td>
                            <td class="details-td-content text-pre-wrap font-weight-bold">{{ product.dispense_regime }}</td>
                        </tr>
                    </template>

                    <template v-if="product.composition">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.composition') }}</td>
                            <td class="details-td-content text-pre-wrap font-weight-bold">{{ product.composition }}</td>
                        </tr>
                    </template>

                    <template v-if="product.pharma_composition">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.pharmClassification') }}</td>
                            <td class="details-td-content text-pre-wrap font-weight-bold">{{ product.pharma_composition.description }}</td>
                        </tr>
                    </template>

                    <template v-if="product.species && product.species.length">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.species') }}</td>
                            <td class="details-td-content font-weight-bold">
                                <span v-for="(item, index) in product.species" :key="index">
                                    {{ item.description }}
                                    <template v-if="index !== product.species.length - 1"><br /></template>
                                </span>
                            </td>
                        </tr>
                    </template>

                    <template v-if="product.administration_route">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.adminRoute') }}</td>
                            <td class="details-td-content text-pre-wrap font-weight-bold">{{ product.administration_route.description }}</td>
                        </tr>
                    </template>

                    <template v-if="product.active_substances && product.active_substances.length">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.activeSubstances') }}</td>
                            <td class="details-td-content font-weight-bold">
                                <span v-for="(item, index) in product.active_substances" :key="index">
                                    {{ item.description }}
                                    <template v-if="index !== product.active_substances.length - 1"><br /></template>
                                </span>
                            </td>
                        </tr>
                    </template>

                    <template v-if="product.dosage">
                        <tr class="description-text font-size-md">
                            <td class="details-td-title description-text">{{ $t('products.dosage') }}</td>
                            <td class="details-td-content text-pre-wrap font-weight-bold">{{ product.dosage }}</td>
                        </tr>
                    </template>
                </table>
                <div id="message_container" class="bottom-of-table"></div>
            </div>
        </div>

        <div class="product-tab" @scroll="onScroll" ref="productTab" v-if="tabIndex === 1">
            <div class="pr-12">
                <table>
                    <tr class="description-text font-size-md">
                        <td class="details-td-title description-text">{{ $t('products.indication') }}</td>
                        <td class="details-td-content font-weight-bold" v-if="product.indications">
                            <span style="white-space: pre-wrap">{{ product.indications }}</span>
                        </td>
                        <td class="details-td-content font-weight-bold" v-else><span>{{ $t('products.noIndications') }}</span></td>
                    </tr>
                </table>
                <div id="message_container" class="bottom-of-table"></div>
            </div>
        </div>

        <div class="product-tab" @scroll="onScroll" ref="productTab" v-if="tabIndex === 2 && userStore.hasPermissionTo('View product stocks')">
            <div class="pr-12">
                <v-data-table
                    ref="datatable"
                    class="elevation-1 mt-2 d-flex flex-column justify-space-between product-details-data-table nowrap-headers"
                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                    fixed-header
                    multi-sort
                    :headers="tHeaders(detailsHeaders)"
                    :header-props="headerProps"
                    :items="stocks"
                    hide-default-footer
                    disable-pagination
                    :no-data-text="$t('table.noData')"
                    :no-results-text="$t('table.noResults')"
                    :loading="!stocks"
                    :loading-text="$t('table.loading')"
                >
                    <template #[`item.stock_id`]="scope">
                        <div style="cursor: pointer">
                            {{ scope.item.stock_id }}
                        </div>
                    </template>

                    <template #[`item.quantity`]="scope">
                        <div style="cursor: pointer">
                            {{ scope.item.quantity }}
                        </div>
                    </template>

                    <template #[`item.expiration_date`]="scope">
                        <div style="cursor: pointer">
                            {{ scope.item.expiration_date }}
                        </div>
                    </template>
                </v-data-table>

                <div id="message_container" class="bottom-of-table"></div>
            </div>
        </div>

        <div v-if="!scrolledToBottom" class="floating-scroll-div">
            <v-btn @click="scrollToBottom" class="btn-bg-color-blue floating-scroll-btn" fab x-small depressed>
                <v-icon color="#154579">mdi-arrow-down-bold</v-icon>
            </v-btn>
        </div>

        <app-dialog :isCampaignPdf="true"  :value="isProductPdfDialogOpen" @input="pdfDialogStatus($event)" :title="pdfDialogTitle" width="60vw" :isResponsive="true" :showActions="true" :hideOverlay="true" contentStyle="height: 75vh; max-height: 75vh; overflow-y: scroll;">
            <template v-slot:content>
                <product-document-dialog :pdfKey="product.code" :docSrc="selectedFilePath"></product-document-dialog>
            </template>

            <template v-slot:buttons="{}">
                <v-btn text outlined class="myprovet-btn-cancel" @click="pdfDialogStatus(false)">{{ $t('common.close') }}</v-btn>
                <v-btn text outlined class="myprovet-btn-ok" @click="downloadFile()">{{ $t('products.download') }}</v-btn>
            </template>
        </app-dialog>

        <app-dialog :isProductVideoDialog="true" :value="isProductVideoDialogOpen" @input="videoDialogStatus($event)" width="60vw" :isResponsive="true" :showActions="true" :hideOverlay="true" contentStyle="height: 75vh; max-height: 75vh; overflow-y: scroll;">
            <template v-slot:content>
                <product-video-dialog v-if="videoSrc && isProductVideoDialogOpen" :visible="isProductVideoDialogOpen" :videoId="videoId" :videoLink="videoSrc" :productCode="product.code"></product-video-dialog>
            </template>
        </app-dialog>

        <purchase-conditions-dialog :value="isProductShippingConditionsDialogOpen" :product="product" @cancel="isProductShippingConditionsDialogOpen = false" @success="purchase" :title="$t('orders.base.information')" width="40vw"> </purchase-conditions-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAffinityOrderStore } from '@/Stores/affinityorder';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';


const defaultQuantity = 1;

export default {
    props: {
        product: Object,

        parentPage: {
            type: String,
            default: 'normal',
        },

        currentSearchTerm: {
            type: String,
        },

        viewingSubstituteProduct: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            datatableSize: 200,
            tabIndex: 0,
            isProductShippingConditionsDialogOpen: false,
            scrolledToBottom: false,
            isMounted: false,
            resizeObserver: null,
            resizeObserverScroll: null,
            pdfDialogTitle: '',
            detailsHeaders: [
                {
                    text: 'Lote',
                    align: 'start-padded',
                    sortable: true,
                    value: 'stock_id',
                    width: '33%',
                },
                {
                    text: 'Quantidade',
                    align: 'center',
                    sortable: true,
                    value: 'quantity',
                    width: '33%',
                },
                {
                    text: 'Validade',
                    align: 'end',
                    sortable: true,
                    value: 'expiration_date',
                    width: '34%',
                },
            ],
            stocks: [],
            isProductVideoDialogOpen: false,
            isProductPdfDialogOpen: false,
            rcmFile: '',
            fsegFile: '',
            pdfSrc: '',
            videoSrc: '',
            videoId: null,
            fileType: '',
            selectedFilePath: '',
            quantity: 1,
            isIpad:false,
        };
    },

    mounted() {
        window.EventBus.$on('closeDialog', this.resetTab);
        this.isMounted = true;

        this.prepareResponsiveBehaviour();

        window.EventBus.$on('updated-product-stocks', ({ data }) => {
            const productStock = data.find((p) => p.code == this.product.code);
            if (productStock) {
                this.$set(this.product, 'has_current_stock', productStock.has_current_stock);
            }
        });
        this.isIpad=this.isIOS()
        this.getRemoteFiles(this.isIpad)
        this.registerBannerProductView()
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.detailsDialog);
        this.resizeObserverScroll?.unobserve(this.$refs.productTab);
        window.EventBus.$off('updated-product-stocks');
    },

    watch: {
        product: {
            handler: function () {
                if (this.rcmFile != '' || this.fsegFile != '') {
                    window.URL.revokeObjectURL(this.rcmFile);
                    window.URL.revokeObjectURL(this.fsegFile);
                    this.rcmFile = '';
                    this.fsegFile = '';
                }

                this.stocks = [];
                this.getStocks();

                /*if(this.isIpad){
                    this.getRemoteFiles(true);
                }else{
                    this.getRemoteFiles();
                }*/

                this.getExtras();

                this.quantity = this.isInCart ? this.product.quantity : defaultQuantity;

                if (this.isMounted) {
                    this.$nextTick(() => {
                        this.initScroll();
                    });
                }
            },
            immediate: true,
        },

        storeQuantity: {
            handler: function (value) {
                this.quantity = value ?? defaultQuantity;
            },
            immediate: true,
        },

        tabIndex: {
            handler: function (value) {
                if (this.isMounted) {
                    this.$nextTick(() => {
                        if (value == 2) {
                            // Stocks tab
                            this.computeDatatableSize(true);
                        } else {
                            this.initScroll();
                        }
                    });
                }
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore, useAffinityOrderStore, useAppStore),

        activeStore() {
            return this.parentPage === 'affinity' ? this.affinityOrderStore : this.normalOrderStore;
        },

        isInCart() {
            const item = this.activeStore.getProduct(this.product.id);

            return item !== undefined;
        },
        storeQuantity() {
            const item = this.activeStore.getProduct(this.product.id);

            return item?.quantity ?? defaultQuantity;
        },
        hasAltProducts() {
            return this.product.substitute_products?.length > 0;
        },
        showAirCargoIcon() {
            //return this.branchStore.branch?.zone === 'ILHAS' && this.product.cold_storage && !this.product.flammable;
            return this.branchStore.branch?.zone === 'ILHAS' && !this.product.air_cargo && this.product.flammable;
        },
        showBoatIcon(){
            return this.branchStore.branch?.zone === 'ILHAS' && this.product.air_cargo==2;
        },
        hasAdditionalInfo() {
            return this.product.psychotropic || this.showAirCargoIcon || this.showBoatIcon || this.product.cold_storage || this.product.serializable || this.product.orderable || this.product.amount_per_package > 0 || this.product.amount_per_pallet > 0;
        },
        maxQuantity() {
            return this.activeStore.maxQuantity;
        },
        hasRcmFile() {
            return this.rcmFile != '';
        },
        hasFsegFile() {
            return this.fsegFile != '';
        },
        isMobile() {
            return this.appStore.isMobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        registerBannerProductView() {
            const urlParams = new URLSearchParams(window.location.search);
            const searchTerm = urlParams.get('q');
            const bannerUuid = urlParams.get('banner');

            if (!bannerUuid || this.currentSearchTerm !== searchTerm) return;

            const formData = new FormData();
            formData.append('user_id', this.userStore.user.id);
            formData.append('branch_id', this.branchStore.branch.id);
            formData.append('product_code', this.product.code);
            navigator.sendBeacon(`/api/analytics/banner/${bannerUuid}/product-view`, formData);
        },

        shareProduct(product){
            const baseUrl = window.location.origin;
            let shareLink=baseUrl+'/orders/normal?q='+_.replace(product.designation,/ /g,'%20')
            const el = document.createElement("textarea");
            el.value = shareLink;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);

            this.copied = true;
            setTimeout(() => (this.copied = false), 2000);
        },
        handleCampaignClick(product) {
            if (this.parentPage == 'summary' || this.parentPage == 'prodReplacementDialog' || this.parentPage == 'prodReplacementDialog') {
                // TODO: Include Pending Products page on the exclusions?
                this.showError(this.$t('products.noCampaignsOnCheckout'));
            } else {
                this.$emit('show-campaigns', product);
            }
        },

        getStocks() {
            if (this.userStore.hasPermissionTo('View product stocks')) {
                axios.get(`/api/products/${this.product.code}/stocks`).then(({ data }) => {
                    this.stocks = data;
                });
            }
        },

        openRcm() {
            this.pdfDialogTitle = 'RCM';
            this.fileType = 'rcm';
            this.selectedFilePath = this.rcmFile;
            //console.log('this.selectedFilePath',this.selectedFilePath);
            //window.open(this.selectedFilePath)
            //return
            if(this.isIpad){
                this.downloadFile()
                /*const iframe = document.createElement('iframe');
                iframe.src =  this.selectedFilePath ;
                iframe.width = '100%';
                iframe.height = '100%';
                iframe.style.border = 'none';

                const newWindow = window.open('', '_blank');
                newWindow.document.body.appendChild(iframe);
                newWindow.document.title = 'My Custom Title';*/
                /*var base64 = (this.selectedFilePath)
                const blob = this.base64ToBlob( base64, 'application/pdf' );
                const url = URL.createObjectURL( blob );
                const pdfWindow = window.open("");
                pdfWindow.document.write('<style>body {margin: 0 !important;}</style><button type="button" onclick="javascript: window.close()">FECHAR</button><iframe width="100%" height="100%" src="' + url + '"></iframe>');*/
             // window.open('data:application/pdf;base64,'+this.selectedFilePath)
            }else{
                this.openPdfDialog();
            }

        },
        base64ToBlob( base64, type = "application/octet-stream" ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                arr[ i ] = binStr.charCodeAt( i );
            }
            return new Blob( [ arr ], { type: type } );
        },

        openFseg() {
            this.pdfDialogTitle = 'FSEG';
            this.fileType = 'fseg';
            this.selectedFilePath = this.fsegFile;
            if(this.isIpad){
                this.downloadFile()
                /*var base64 = (this.selectedFilePath)
                const blob = this.base64ToBlob( base64, 'application/pdf' );
                const url = URL.createObjectURL( blob );
                const pdfWindow = window.open("");
                pdfWindow.document.write("<style>body {margin: 0 !important;}</style><iframe width='100%' height='100%' src='" + url + "'></iframe>");*/
                /*var base64 = (this.selectedFilePath)
                const blob = this.base64ToBlob( base64, 'application/pdf' );
                const url = URL.createObjectURL( blob );
                const pdfWindow = window.open("");
                pdfWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");*/
             // window.open('data:application/pdf;base64,'+this.selectedFilePath)
            }else{
                this.openPdfDialog();
            }
        },

        openPdf() {
            this.pdfDialogTitle = 'PDF';
            this.fileType = 'pdf';
            this.selectedFilePath = this.pdfSrc;
            if(this.isIpad){
                this.downloadFile()
            }else{
                this.openPdfDialog();
            }
        },

        openPdfDialog() {
            this.isProductPdfDialogOpen = true;
        },

        openVideoDialog() {
            this.isProductVideoDialogOpen = true;
        },

        downloadFile() {
            if (this.fileType === 'rcm' || this.fileType === 'fseg') {
                this.downloadBase64File();
                return;
            }

            axios({
                url: this.selectedFilePath,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                const splitPath = this.selectedFilePath.split('/');
                fileLink.download = splitPath[splitPath.length - 1];

                fileLink.click();
            });
        },

        downloadBase64File() {
            if (this.fileType === 'rcm' && this.rcmFile == '') {
                this.showError(this.$t('products.downloadError'));
                return;
            }

            if (this.fileType === 'fseg' && this.fsegFile == '') {
                this.showError(this.$t('products.downloadError'));
                return;
            }

            let fileURL = this.fileType === 'rcm' ? this.rcmFile : this.fsegFile;
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let filename = this.fileType === 'rcm' ? this.product.code + '_rcm' : this.product.code + '_fseg';
            fileLink.download = 'file_' + filename + '.pdf';

            fileLink.click();
        },

        pdfDialogStatus(status) {
            if (!status) {
                this.selectedFilePath = '';
            }
            this.isProductPdfDialogOpen = status;
        },

        videoDialogStatus(status) {
            if (!status) {
                this.selectedFilePath = '';
            }
            this.isProductVideoDialogOpen = status;
        },

        prepareResponsiveBehaviour() {
            // Table responsivity
            const makeResponsive = () => {
                this.$nextTick(() => {
                    this.computeDatatableSize();
                });
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            window.addEventListener('resize', makeResponsive);
            this.resizeObserverScroll = new ResizeObserver(() => {
                this.initScroll();
            });

            // Scroll arrow
            this.$nextTick(() => {
                this.initScroll();

                this.resizeObserver.observe(this.$refs.detailsDialog);
                this.resizeObserverScroll.observe(this.$refs.productTab);
            });

            // makeResponsive();
        },

        computeDatatableSize(initScrollAfter = false) {
            const dialog = this.$refs.detailsDialog;
            const tab = this.$refs.productTab;

            if (!dialog || !tab) {
                return;
            }

            // const dialogHeight = dialog.getBoundingClientRect().bottom - dialog.getBoundingClientRect().top;
            const dialogHeight = tab.getBoundingClientRect().height;

            const res = dialogHeight - 20;
            this.datatableSize = res;

            if (initScrollAfter) {
                this.$nextTick(() => {
                    this.initScroll();
                });
            }
        },

        resetTab() {
            this.tabIndex = 0;
        },
        initScroll() {
            if (!this.$refs.productTab) {
                return;
            }

            if (this.$refs.productTab.scrollTop == 0 && this.$refs.productTab.clientHeight == this.$refs.productTab.scrollHeight) {
                return (this.scrolledToBottom = true);
            }
            this.$refs.productTab.scrollTop + this.$refs.productTab.clientHeight >= this.$refs.productTab.scrollHeight ? (this.scrolledToBottom = true) : (this.scrolledToBottom = false);
        },
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            //Checks if div has a scroll and if it's reached the bottom yet
            scrollTop + clientHeight >= scrollHeight - 1 ? (this.scrolledToBottom = true) : (this.scrolledToBottom = false);
        },
        scrollToBottom() {
            const el = this.$el.getElementsByClassName('bottom-of-table')[0];

            if (el) {
                el.scrollIntoView();
            }
        },
        changeProduct(product) {
            this.$emit('change-product', product);
        },
        isAvailable(product) {
            return product.has_current_stock;
        },
        increment(amount) {
            if (!this.isInCart) {
                this.quantity += amount;

                if (this.quantity <= 0) {
                    this.quantity = defaultQuantity;
                }

                this.quantity = this.parseQuantity(this.quantity);

                this.$forceUpdate();
                return;
            }

            this.activeStore.incrementProductQuantity(this.product.id, amount);
        },
        onQuantityUpdated(amount) {
            this.quantity = this.parseQuantity(amount);

            if (!this.isInCart) {
                return;
            }

            this.activeStore.setProductQuantity(this.product.id, this.quantity);
        },
        tryPurchase() {
            this.quantity = this.parseQuantity(this.quantity);
            if (this.quantity < 1) this.quantity = 1;

            if (!this.isInCart && this.normalOrderStore.isSpecialProduct(this.product)) {
                this.isProductShippingConditionsDialogOpen = true;
                return;
            }

            this.purchase();
        },
        purchase() {
            this.isProductShippingConditionsDialogOpen = false;
            this.product.quantity = this.quantity;

            this.activeStore.addProduct(this.product, this.currentSearchTerm);
        },
        remove() {
            this.quantity = defaultQuantity;

            this.activeStore.removeProduct(this.product.id);
        },
        getExtras() {
            this.pdfSrc = '';
            this.videoSrc = '';
            this.videoId = null;

            axios
                .get(`/api/products/${this.product.code}/extra-files`)
                .then((response) => {
                    this.pdfSrc = response.data?.pdf ?? '';
                })
                .catch(() => {
                    this.pdfSrc = '';
                });

            axios
                .get(`/api/products/${this.product.code}/video`)
                .then((response) => {
                    this.videoSrc = response.data?.video;
                    this.videoId = response.data?.id;
                })
                .catch(() => {
                    this.videoSrc = '';
                    this.videoId = null;
                });
        },
        getRemoteFiles(path) {
            const url = '/api/products/download/remote-files';
            let getPath= typeof path != 'undefined' ?true:false
            //console.log('getPath',getPath,path,typeof path != 'undefined');
            // Get RCM file
            axios({
                    url,
                    responseType: 'blob',//getPath? 'json':'blob',
                    params: {
                        type: 'rcm',
                        code: this.product.code,
                        path: false//getPath ?true:false
                    },
                })
                .then((response) => {
                    //console.log('response',response);
                    /*if(!getPath){
                        const blob = new Blob([response.data]);
                        const objectUrl = window.URL.createObjectURL(blob, { type: 'application/pdf' });
                        this.rcmFile = objectUrl;
                    }else{
                        const blob = new Blob([response.data]);
                        const objectUrl = window.URL.createObjectURL(blob, { type: 'application/pdf' });
                        this.rcmFile = objectUrl;

                    }*/
                    const blob = new Blob([response.data]);
                        const objectUrl = window.URL.createObjectURL(blob, { type: 'application/pdf' });
                        this.rcmFile = objectUrl;
                })
                .catch((error) => {
                    this.rcmFile = '';
                });

            // Get FSEG file
            axios({
                    url,
                    responseType: 'blob',//getPath?'json':'blob',
                    params: {
                        type: 'fseg',
                        code: this.product.code,
                        path: false//getPath?true:false
                    },
                })
                .then((response) => {
                    /*if(getPath){
                        const blob = new Blob([response.data]);
                        const objectUrl = window.URL.createObjectURL(blob, { type: 'application/pdf' });
                        this.fsegFile = objectUrl;
                    }else{
                        this.fsegFile = response.data;
                    }*/
                    const blob = new Blob([response.data]);
                    const objectUrl = window.URL.createObjectURL(blob, { type: 'application/pdf' });
                    this.fsegFile = objectUrl;
                })
                .catch(() => {
                    this.fsegFile = '';
                });
        },
        productHasActiveCampaign(productId) {
            return this.normalOrderStore.hasActiveCampaign(productId);
        },
    },
};
</script>

<style>
.product-details-data-table > .v-data-table__wrapper > table > thead > tr > th:last-of-type {
    padding-left: 16px !important;
    padding-right: 16px !important;
}

.product-details-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.6rem !important;
    height: 25px !important;
    color: black !important;
    line-height: unset !important;
}

.product-details-data-table > div > table > thead > tr > th:last-of-type {
    padding-left: 16px !important;
    padding-right: 16px !important;
}
</style>

<style scoped>
.set-field-size {
    min-width: 80px;
    max-width: 80px;
}

.lowercase-button {
    text-transform: unset !important;
}

table {
    border-collapse: collapse;
}

td:first-child {
    padding-right: 2em;
}

td {
    padding-top: 0.1em;
    padding-bottom: 0.1em;
    vertical-align: top;
}

tr:first-child > td {
    padding-top: 0;
}

tr:not(:first-child) {
    border-top: 2px solid #e9f7fd !important;
}

.details-td-title {
    width: 20vw;
}

.details-td-content {
    width: 80vw;
    text-align: justify;
}

.product-tab {
    min-height: 18vh;
    max-height: 18vh;
    overflow-y: scroll;
    margin-right: -24px;
    padding-left: 16px;
}

.product-image {
    min-height: 30vh;
    max-height: 30vh;
}

.details-tabs {
    margin-top: 16px;
    margin-bottom: 16px;
}

.product-details-bigger-text {
    /*From vuetify's text-h6, customized for our needs*/
    font-size: 1.2rem;
    letter-spacing: 0.0125em;
    font-weight: 700 !important;
    cursor: default !important;
}

.product-details-big-text {
    /*From vuetify's text-h6, customized for our needs*/
    font-size: 1rem;
    letter-spacing: 0.0125em;
    font-weight: 700 !important;
    cursor: default !important;
}

.product-details-name {
    height: 40px;
    line-height: 1.8rem;
}

.product-details-laboratory {
    height: 20px;
    line-height: 1.8rem;
}

.media-icons {
    text-align: left !important;
    width: fit-content !important;
}

.product-replaced-by-text {
    margin-top: 2px;
    word-break: normal !important;
}

.floating-scroll-div {
    float: right;
    z-index: 99;
    position: absolute;
    right: 25px;
    bottom: 0px;
}

.floating-scroll-btn {
    margin-top: -50px;
    margin-right: -13px;
}

.bottom-of-table {
    height: 0px;
}

.new-product-label {
    position: absolute;
    top: 36px;
    left: 22px;
    -webkit-box-shadow: 0px 5px 3px 0px rgb(0, 0, 0, 0.25);
    box-shadow: 0px 5px 3px 0px rgb(0, 0, 0, 0.25);
}

@media only screen and (min-height: 720px) {
    .product-tab {
        min-height: 19vh;
        max-height: 19vh;
    }

    td {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        vertical-align: top;
    }
}

@media only screen and (min-height: 770px) {
    .product-tab {
        min-height: 19vh;
        max-height: 19vh;
    }
}

@media only screen and (min-height: 860px) {
    .product-tab {
        min-height: 32vh;
        max-height: 32vh;
    }
}

@media only screen and (min-height: 920px) {
    .product-tab {
        min-height: 32vh;
        max-height: 32vh;
    }

    .details-tabs {
        margin-top: 24px;
        margin-bottom: 16px;
    }

    .product-details-bigger-text {
        /*From vuetify's text-h6, customized for our needs - original values*/
        font-size: 1.25rem;
        font-weight: 700 !important;
        cursor: default !important;
    }

    .product-details-big-text {
        /*From vuetify's text-h6, customized for our needs - original values*/
        font-size: 1.05rem;
        font-weight: 700 !important;
        cursor: default !important;
    }

    .product-details-name {
        height: 50px;
        line-height: 2rem;
    }

    .product-details-laboratory {
        height: 20px;
        line-height: 1.8rem;
    }
}

@media only screen and (min-height: 1300px) {
    .product-tab {
        min-height: 33vh;
        max-height: 33vh;
    }
}

/*Limits horizontal button space to allow media icons to appear properly*/
@media only screen and (max-width: 1620px) {
    .details-btn-small {
        width: 1% !important;
        min-width: 130px !important;
        margin-right: 16px !important;
        margin-left: 16px !important;
    }
}
</style>
